<template>
  <div class="flex-row-start-start gap-2 w-100 direction-ltr">
    <div class="bullet" :class="{ selected: selected }">
      <div></div>
    </div>
    <div class="radio-title">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: "Radio",

  props: {
    selected: { type: Boolean, required: true },
    title: { type: String, required: true },
  },
};
</script>

<style lang="scss" scoped>
.radio-title {
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
}
.bullet {
  width: 18px;
  height: 18px;
  border: 1px solid var(--v-mainBlue-base);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  & div {
    width: 12px;
    height: 12px;
    border: 1px solid var(--v-mainBlue-base);
    border-radius: 50%;
  }
}
.selected {
  & div {
    background: var(--v-mainRed-base);
  }
}
</style>
